import getSelectedElementUuids from 'editor/src/store/editor/selector/getSelectedElementUuids';
import { RootState } from 'editor/src/store/index';

import getStructureIndexesByElementUuids from './getStructureIndexesByElementUuids';

const getStructureIndexesOfSelectedElements = (state: RootState) =>
  getStructureIndexesByElementUuids(state, getSelectedElementUuids(state));

export default getStructureIndexesOfSelectedElements;
